// remove spaces and dividers and convert values to lowercase
export const formattedRfidCode = (rfidCode: string): string => {
  return rfidCode.toLowerCase().replace(/[\s:]+/g, '');
};
